export const LETTER_TOTALS: Record<string, number> = {
  "!": 1,
  "#": 1,
  $: 1,
  "&": 1,
  "'": 2, // represented with same character as -
  "(": 2, // represented with same character as )
  ")": 2, // represented with same character as (
  "*": 1,
  "+": 1,
  ",": 3,
  "-": 2, // represented with same character as '
  ".": 3,
  "0": 4,
  "1": 4,
  "2": 3,
  "3": 3,
  "4": 3,
  "5": 3,
  "6": 3,
  "7": 3,
  "8": 3,
  "9": 3,
  "?": 1,
  "@": 2,
  A: 8,
  B: 3,
  C: 5,
  D: 5,
  E: 9,
  F: 3,
  G: 3,
  H: 5,
  I: 8,
  J: 2,
  K: 2,
  L: 6,
  M: 4,
  N: 7,
  O: 8,
  P: 4,
  Q: 2,
  R: 7,
  S: 8,
  T: 8,
  U: 7,
  V: 2,
  W: 2,
  X: 2,
  Y: 4,
  Z: 2,
  "{": 1,
  "}": 1,
  "~": 1,
  "¢": 1,
};
